import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import EnotesTable from './EnotesTable';
const Enotes = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Enotes' parent='Enotes'  />
      <Container fluid={true}>
        <Row>
          <EnotesTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Enotes;
